/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/theater/showtimes/movieShowtimeGroupings.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'theater/showtimes/movieShowtimeGroupings', exports: {} };
const exports = module.exports;



import { Fandango as Fandango_account_context_logInUrls_pageDetails } from '@take-2/fd-modules/splits/require-core';

const { account: { isVerifiedLoggedIn }, context, logInUrls, pageDetails } = Fandango_account_context_logInUrls_pageDetails;


import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from '@take-2/fd-modules/splits/require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


import { Fandango_util as Fandango_util_formatDate } from '@take-2/fd-modules/splits/require-global';

const { formatDate } = Fandango_util_formatDate;


import { fd_location as fd_location_getLocation } from '@take-2/fd-modules/splits/require-global';

const { getLocation } = fd_location_getLocation;


import { Fandango_queryUtil as Fandango_queryUtil_getParam_removeParam } from '@take-2/fd-modules/splits/require-core';

const { getParam, removeParam } = Fandango_queryUtil_getParam_removeParam;


import { Fandango_cookie as Fandango_cookie_get_getCookie } from '@take-2/fd-modules/splits/require-core';

const { get: getCookie } = Fandango_cookie_get_getCookie;


import { global_consts as global_consts_CookieNames_QueryParams } from '@take-2/fd-modules/splits/require-core';

const { CookieNames, QueryParams } = global_consts_CookieNames_QueryParams;


import $ from '@take-2/fd-modules/jQuery';



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { fd_url_manager as links } from '@take-2/fd-modules/splits/require-core';



import modal from '@take-2/fd-modules/Fandango/modal';



import { swig as swig } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';



import { Fandango as Fandango_context } from '@take-2/fd-modules/splits/require-core';

const { context: { featureFlags: { seatMapPreviewEnabled } } } = Fandango_context;


import seatMap from '@take-2/fd-modules/shared/seatMap/seatMap';



import amenityDropdown from '@take-2/fd-modules/desktop/shared/amenityDropdown';



import expandedSearch from '@take-2/fd-modules/theater/showtimes/expandedSearch';



import hearts from '@take-2/fd-modules/shared/utils/hearts';



import locationHelpers from '@take-2/fd-modules/theater/showtimes/locationHelpers';



import pagination from '@take-2/fd-modules/desktop/shared/pagination';



import { shared_global_smoothScroll as smoothScroll } from '@take-2/fd-modules/splits/require-global';



import sharedShowtimes from '@take-2/fd-modules/shared/sharedShowtimes';



const { expandedSearch: expandedSearchEnabled, joinNowURL, openChainFilterEnabled, partnerRestrictedTicketing, } = readPageContext(context, pageDetails, logInUrls)


let redirectUrl


const Selectors = {
    FILTER_BTN: '.js-filteredChain-btn',
    FILTER_LOADING: '.js-filteredChain-lazy',
    LOCATION_ERR_CONTAINER: '.js-date-picker__error ',
    NEARBY_THEATERS: '.js-nearby-theaters',
    OFFER_CTA: '.js-offer-cta',
    SHARED_MOVIE_SHOWTIMES: 'shared-movie-showtimes', // id
    SHARED_SHOWTIMES: 'shared-showtimes', // id
    SHARED_THEATER_HEADER: 'shared-theater-header', // id
    SHOWTIMES_CONTAINER: '.js-theaterShowtimes-loading',
    SHOWTIMES_ERROR_CONTAINER: '.js-fd-showtimes__error-msg',
    SHOWTIMES_PLACEHOLDER: '.js-showtimes-placeholder',
}


const ErrorMsgs = {
    LOCATION_NOT_FOUND: 'This location can\'t be found. Please enter a different city or ZIP Code to find theaters near you.',
    NO_DATA: 'Oh dear... It looks like something went wrong.  Please try again later.',
    NO_FAV_THEATERS: 'Have a favorite theater? Save it to \'My Theaters\' to easily find showtimes and buy tickets by clicking the <span class="icon icon-fave-heart--white-outline fd-movie__follow-icon"></span> button.'
}


const Styles = {
    HIDE: 'hide'
}


const FilterOptions = {
    ALL_THEATERS: 'all-theaters',
    MY_THEATERS: 'my-theaters',
    OPEN_THEATERS: 'open-theaters',
    TICKETING_THEATERS: 'ticketing-theaters'
}


const HTML = {
    ERROR_MSG: '<div class="dark__section fd-showtimes__error-msg js-fd-showtimes__error-msg"></div>',
}


const MAX_RESULTS_PER_PAGE = 10


let currentLocation = null


let apiQueryParams = {}
function readPageContext(context, pageDetails, logInUrls) {
    return {
        chainID: context.theater.chainID,
        expandedSearch: pageDetails.expandedSearch,
        joinNowURL: logInUrls.joinNow,
        openChainFilterEnabled: context.featureFlags.openChainFilterEnabled,
        partnerRestrictedTicketing: pageDetails.partnerRestrictedTicketing,
    };
}
function altRedemptionRedirect(url) {
    window.location.replace(url);
}
function showErrorMsg(msg) {
    $(Selectors.SHOWTIMES_PLACEHOLDER).remove();
    $(Selectors.SHOWTIMES_CONTAINER).html(HTML.ERROR_MSG);
    $(Selectors.SHOWTIMES_ERROR_CONTAINER).html(msg);
}
function renderTheaterError() {
    const errorMarkup = swig.render('_noTheatersError', {
        openFilterEnabled: openChainFilterEnabled
    });
    showErrorMsg(errorMarkup);
}
function onTheatersDone(data, params, cb = () => { }) {
    $(Selectors.LOCATION_ERR_CONTAINER).addClass(Styles.HIDE);
    if (!data) {
        return showErrorMsg(ErrorMsgs.NO_DATA);
    }
    if (data.noShowtimesRedirect && redirectUrl) {
        return altRedemptionRedirect(redirectUrl);
    }
    if (data.error && data.attemptedLocation) {
        return showErrorMsg(ErrorMsgs.LOCATION_NOT_FOUND);
    }
    if (data.noFavTheaters) {
        return showErrorMsg(ErrorMsgs.NO_FAV_THEATERS);
    }
    if (!data.theaters || (!data.theaters.length && !data.chainInfo)) {
        return renderTheaterError();
    }
    if (data.chainInfo && !data.theatersFilteredByChain.length) {
        return renderTheaterError();
    }
    if (data.expandedSearch) {
        expandedSearch.setExpanded(currentLocation);
    }
    const paginationMarkup = swig.render('_pagination', data.pagination);
    const date = new Date(params.date);
    const anchor = getParam(QueryParams.MOVE_TO) || window.location.hash.slice(1);
    const theaters = data.chainInfo ? data.theatersFilteredByChain : data.theaters;
    const viewModel = { includeTheaterHeader: true, pagination: paginationMarkup, theaters };
    const markup = swig.render('_showtimes', viewModel);
    $(Selectors.SHOWTIMES_CONTAINER).html(markup);
    theaters.forEach((theater) => {
        const theaterHeaderEl = document.getElementById(`${Selectors.SHARED_THEATER_HEADER}-${theater.id}`);
        const displayTheater = { ...theater, theaterPageUrl: `${theater.theaterPageUrl}${removeParam(QueryParams.PAGE) || ''}` };
        const innerContent = swig.render('_sharedTheaterHeaderContent', {
            isFullLinkHeader: false,
            showAddress: true,
            showAmenities: true,
            showMap: true,
            theater: displayTheater
        });
        if (theaterHeaderEl) {
            theaterHeaderEl.outerHTML = swig.render('_sharedTheaterHeader', {
                concessionsEnabled: data.concessionsEnabled,
                innerContent,
                isVerifiedLoggedIn: data.isLoggedIn || isVerifiedLoggedIn,
                theater: displayTheater,
            });
        }
        if (theater.movies?.length) {
            const movieShowtimesEl = document.getElementById(`${Selectors.SHARED_MOVIE_SHOWTIMES}-${theater.id}`);
            if (movieShowtimesEl) {
                movieShowtimesEl.outerHTML = swig.render('_sharedMovieShowtimes', { movies: theater.movies, theater });
            }
            theater.movies.forEach((movie) => {
                const showtimesEl = document.getElementById(`${Selectors.SHARED_SHOWTIMES}-${theater.id}-${movie.id}`);
                if (showtimesEl) {
                    // Deduplicate amenities: exclude text-only amenities when an image version exists
                    movie.variants.forEach((variant) => {
                        variant.amenityGroups.forEach((group) => {
                            if (group.amenitiesWithImage?.length) {
                                const imageAmenityIds = new Set(group.amenitiesWithImage.map(a => a.id));
                                group.amenities = group.amenities.filter(a => !imageAmenityIds.has(a.id));
                            }
                        });
                    });
                    // Check if seat map is disabled for the theater
                    const disabledChains = pageDetails?.disabledSeatMaps || [];
                    const chainSeatMapDisabled = disabledChains.includes(theater.chainCode);
                    showtimesEl.innerHTML = swig.render('_sharedShowtimes', {
                        chainSeatMapDisabled,
                        movie,
                        seatMapPreviewEnabled,
                        showtimeDate: [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'),
                        theater,
                        variants: !chainSeatMapDisabled ? seatMap.addSeatMapData(movie.variants) : movie.variants,
                    });
                }
            });
        }
    });
    sharedShowtimes.init();
    seatMap.renderModal();
    smoothScroll.run(anchor);
    amenityDropdown.run();
    hearts.init();
    pagination.attach({ onChange: page => getGroupings(page, cb) });
    modal.offers(Selectors.OFFER_CTA);
    cb(data.theaters);
}
function onTheatersFail(err) {
    debugLog.warn('theaterAPI Fail', err);
    $(Selectors.SHOWTIMES_CONTAINER).remove();
}
function onNearbyTheaterChange() {
    window.location = this.value;
}
function getGroupings(page, cb) {
    $(Selectors.SHOWTIMES_CONTAINER).html(swig.render('_tspShowtimesPlaceholderDesktop'));
    apiQueryParams.page = page || 1;
    xhr.ajax({
        method: 'GET',
        url: links.napiTheaterWithShowtimes(),
        data: apiQueryParams
    })
        .done(data => onTheatersDone(data, apiQueryParams, cb))
        .fail(onTheatersFail);
}
function init(cb) {
    $(Selectors.NEARBY_THEATERS).on('change', onNearbyTheaterChange);
    redirectUrl = getParam(QueryParams.NO_THEATER_URL);
    const filter = getParam(QueryParams.FILTER);
    const isMovieTimesPage = window.location.pathname === '/movietimes';
    const location = isMovieTimesPage ? getLocation() : locationHelpers.getLocationFromURL(document.location.pathname);
    currentLocation = '';
    if (location.zip) {
        currentLocation = location.zip;
    }
    else if (location.city && location.state) {
        currentLocation = `${location.city}, ${location.state}`;
    }
    else if (location.name) {
        currentLocation = location.name;
    }
    const useExpandedSearch = currentLocation && expandedSearchEnabled || expandedSearch.useExpanded(currentLocation) || undefined;
    if (useExpandedSearch) {
        expandedSearch.setExpanded(currentLocation);
    }
    apiQueryParams = {
        zipCode: location.zip || '',
        city: location.city || '',
        state: location.state || '',
        date: dateFromQuery() || formatDate(new Date()),
        page: 1,
        favTheaterOnly: filter === FilterOptions.MY_THEATERS,
        limit: MAX_RESULTS_PER_PAGE,
        isdesktop: true,
        filter: filter || (openChainFilterEnabled ? FilterOptions.OPEN_THEATERS : FilterOptions.ALL_THEATERS),
        filterEnabled: openChainFilterEnabled && (filter === FilterOptions.OPEN_THEATERS || !filter),
        chainCode: getParam(QueryParams.CHAIN_ID) || getCookie(CookieNames.CHAIN_CODE) || undefined,
        expandedSearch,
        partnerRestrictedTicketing,
        joinNowURL,
    };
    getGroupings(getParam(QueryParams.PAGE), cb);
}
export default {
    init
};
